import React, { useState, useContext, useEffect } from 'react';
import { Redirect, useHistory } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import { userLogin } from '../../../services/auth';
import { AuthContext } from '../../../context/auth';
import { RegistrationContext } from '../../context/registration';
import { useToasts } from 'react-toast-notifications';

import { campaignPatientName } from '~/services/registration';

import { TextInput, SelectInput } from '~/shared/components/form/Inputs';
import { CheckBox } from '~/shared/components/form/CheckBox';
import { ProgressBar } from './ProgressBar';
import {
    Container,
    Button,
    Card,
    CardBody,
    CardText,
    CardTitle,
    Col,
    Row,
    Form,
    FormGroup,
    FormText,
    Input,
    Label,
} from 'reactstrap';

import { SelectOption } from '~/types/globals';
import { Loading } from '../../shared/components/Loading';

export const PatientName = ({}: any) => {
    const [{ campaignRequest }, registrationDispatch] =
        useContext(RegistrationContext);
    const {
        register,
        handleSubmit,
        watch,
        errors,
        control,
        reset,
        setValue,
        getValues,
        formState: { isSubmitting, isValid },
    } = useForm({
        first_name: '',
        last_name: '',
        nickname: '',
    });
    if (errors) {
        console.log('errors: ', errors);
    }
    const { addToast } = useToasts();
    const history = useHistory();

    const onSubmit = async (data) => {
        console.log('data: ', data);
        try {
            history.push('/get-started/patient/details', { data });
        } catch (e) {
            console.log('e: ', e);
        }
    };

    return (
        <Container>
            <ProgressBar selectedStep='patient' />

            <Row className='justify-content-center py-5'>
                <Col md='6'>
                    <div className='text-center'>
                        <h3>Who are you fundraising in honor of?</h3>
                    </div>

                    <Card
                        className='box-shadow my-5'
                        style={{
                            maxWidth: '400px',
                            marginLeft: 'auto',
                            marginRight: 'auto',
                        }}
                    >
                        <CardBody>
                            <Form onSubmit={handleSubmit(onSubmit)}>
                                <TextInput
                                    name='first_name'
                                    label='First Name'
                                    control={control}
                                    errors={errors?.first_name?.message}
                                    required={true}
                                    ariaRequired={true}
                                />
                                <TextInput
                                    name='last_name'
                                    label='Last Name'
                                    control={control}
                                    errors={errors?.last_name?.message}
                                    required={true}
                                    ariaRequired={true}
                                />
                                <TextInput
                                    name='nickname'
                                    label='Nickname'
                                    control={control}
                                    errors={errors?.last_name?.message}
                                    helperText='Optional to help people find their campaign.'
                                />
                                <div className='text-center'>
                                    <Button
                                        color='primary'
                                        type='submit'
                                        disabled={!isValid || isSubmitting}
                                    >
                                        {isSubmitting ? `Saving...` : `Next`}
                                    </Button>
                                </div>
                            </Form>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};
